// Module
var code = "<svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.418 11.677a2 2 0 0 0 0-3.354l-6.329-4.11C7.76 3.347 6 4.302 6 5.89v8.22c0 1.587 1.759 2.542 3.09 1.678l6.328-4.11z\"/></svg>";
// Exports
module.exports = code;